import { useEffect, useState } from "react";

export function useIsCompact(breakpointPx: number = 768) {
  const [isCompact, setIsCompact] = useState<boolean>(false);

  useEffect(() => {
    function update() {
      setIsCompact(window.innerWidth < breakpointPx);
    }

    update(); // run once on mount
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, [breakpointPx]);

  return isCompact;
}
